import React from "react"

import classNames from "classnames"

import { Hoverlay } from "shared/ui/hoverlay/Hoverlay"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export interface ProductConfiguratorOptionImageProps {
  canDelete?: boolean
  isDisabled?: boolean
  image: React.ReactNode
}

export const ProductConfiguratorOptionImage = React.memo(
  ({ canDelete, image, isDisabled }: ProductConfiguratorOptionImageProps) => (
    <div className="product-configurator-option__image-container">
      <Hoverlay
        overlay={
          canDelete ? (
            <div
              className={classNames(
                "product-configurator-option__delete-overlay",
                { disabled: isDisabled }
              )}
            >
              <Icon name={IconName.BIN} />
            </div>
          ) : null
        }
      >
        <div className="product-configurator-option__image">{image}</div>
      </Hoverlay>
    </div>
  )
)
